/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Oci_Number_ShortInputs */

const en_cargos_oci_number_short = /** @type {(inputs: Cargos_Oci_Number_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI #`)
};

const es_cargos_oci_number_short = /** @type {(inputs: Cargos_Oci_Number_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCI #`)
};

/**
* | output |
* | --- |
* | "OCI #" |
*
* @param {Cargos_Oci_Number_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_oci_number_short = /** @type {((inputs?: Cargos_Oci_Number_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Oci_Number_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_oci_number_short(inputs)
	return es_cargos_oci_number_short(inputs)
});